function _(s,n,o){const t=s(141);class u extends t.Axis{constructor(s){super(s)}}o.ContinuousAxis=u,u.__name__="ContinuousAxis"}
//# sourceMappingURL=continuous_axis.min.js.map